export const HEADER_BUTTONS_REGION_ID = 'headerButtonsRegionId';

/**
 * Browser widths above this threshold means the search box width will be based
 * on browser width instead of a fixed value.
 */
export const DYNAMIC_WIDTH_THRESHOLD = 1366;

/**
 * If the browser width is under DYNAMIC_WIDTH_THRESHOLD, the search box width
 * will be this value.
 */
export const SMALL_SCREEN_SEARCHBOX_WIDTH = 468;

/**
 * If the browser width is equal to or greater than DYNAMIC_WIDTH_THRESHOLD, the
 * search box width will be this percentage of the user's browser width.
 */
export const DYNAMIC_WIDTH_MODIFIER = 0.45;

/**
 * The FlexPane ID for the Getting Started FlexPane
 */
export const GETSTARTED_FLEXPANE_ID = 'getStartedPane';

/**
 * The FlexPane ID for the What's New FlexPane
 */
export const WHATSNEW_FLEXPANE_ID = 'whatsNewPane';

/**
 * The FlexPane ID for the Activity Feed FlexPane
 */
export const ACTIVITYFEED_FLEXPANE_ID = 'OwaActivityFeed';
